module.exports = "<span class=\"cian-serp-range\">\n  <input\n    ng-repeat=\"input in ::serpRange.inputs\"\n    type=\"number\"\n    class=\"s-input s-input_length_xs\"\n    ng-attr-placeholder=\"{$ ::input.placeholder $}\"\n    ng-model=\"serpRange.source.value[input.key]\"\n    cian-limit-number=\"serpRange.limitConfig\"\n    >\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/serp/directives/range/range.html
// module id = 1006
// module chunks = 0